<!--智慧水厂-数据监测-->
<template>
  <div class="data-monitoring-container">
    <!-- 顶部标题栏 -->
    <div class="header-section">
      <div class="title-wrapper">
        <h2 class="page-title">桂枝岭水厂数据监测</h2>
      </div>
      <div class="action-wrapper">
        <a-select v-model="selectedPlant" style="width: 200px; margin-right: 16px;">
          <a-select-option value="guizhiling">桂枝岭水厂</a-select-option>
        </a-select>
        <a-button type="primary">
          <a-icon type="swap" /> 切换水厂
        </a-button>
      </div>
    </div>

    <!-- 核心卡片网格 -->
    <div class="content-section">
      <a-row type="flex" :gutter="[20, 20]">
        <!-- 第一行 -->
        <a-col :span="16" style="display: flex;">
          <water-quality-monitoring style="flex: 1;" />
        </a-col>
        <a-col :span="8" style="display: flex;">
          <factory-water-quality-monitoring style="flex: 1;" />
        </a-col>

        <!-- 第二行 -->
        <a-col :span="16" style="display: flex;">
          <alarm-monitoring style="flex: 1;" />
        </a-col>
        <a-col :span="8" style="display: flex;">
          <today-alarm style="flex: 1;" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import WaterQualityMonitoring from './modules/WaterQualityMonitoring.vue'
import FactoryWaterQualityMonitoring from './modules/FactoryWaterQualityMonitoring.vue'
import AlarmMonitoring from './modules/AlarmMonitoring.vue'
import TodayAlarm from './modules/TodayAlarm.vue'

export default {
  name: 'DataMonitoring',
  components: {
    WaterQualityMonitoring,
    FactoryWaterQualityMonitoring,
    AlarmMonitoring,
    TodayAlarm
  },
  data () {
    return {
      selectedPlant: 'guizhiling'
    }
  }
}
</script>

<style lang="less" scoped>
.data-monitoring-container {
  background-color: #f0f2f5;
  min-height: 100vh;

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 16px 24px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .page-title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }

  .content-section {
    /deep/ .ant-card {
      display: flex;
      flex-direction: column;
      height: 100%;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

      .ant-card-head {
        border-bottom: 1px solid #f0f0f0;

        .ant-card-head-title {
          font-weight: 600;
          color: #333;
        }
      }

      .ant-card-body {
        flex: 1;
        padding: 16px;
      }
    }
  }
}
</style>
